import { 
    apiRequest,
    cutiCreate,
    getMinDate,
    checkDate
} from '../../../../../../services/adapters/kepegawaian/cutiService'

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", cutiCreate, {
            body: query
        }, true)
    }

    fetchMinDate = async (query, cancelToken) => {
        return await apiRequest("get", getMinDate, {
            params: query
        }, true)
    }

    fetchCheckDate = async (query, cancelToken) => {
        return await apiRequest("get", checkDate, {
            params: query
        }, true)
    }
}

export default CreateRepository